import StepCompletionLink from '@cohort/merchants/apps/common/triggers/StepCompletionLink';
import {TIKTOK_URL} from '@cohort/shared/apps/tiktok/common';
import type {TikTokLikeTiktokVerificationAttemptData} from '@cohort/shared/apps/tiktok/triggers/likeTiktok';
import {Trans} from 'react-i18next';

const TikTokLikeTiktokTriggerStepCompletionTitleComponent: React.FC<{
  data: TikTokLikeTiktokVerificationAttemptData;
  completionSuccess: boolean;
}> = ({data}) => {
  const userLink = `${TIKTOK_URL}/@${data.username}`;

  return (
    <Trans
      i18nKey="triggers.like-tiktok.stepCompletionTitleComponent.success"
      ns="app-tiktok"
      values={{username: data.username}}
      components={{
        userLink: <StepCompletionLink url={userLink} />,
        tiktokLink: <StepCompletionLink url={data.url} />,
      }}
    />
  );
};

export default TikTokLikeTiktokTriggerStepCompletionTitleComponent;
